import { Button } from "@material-tailwind/react";
import React, { useContext } from "react";
import CheckoutForm from "../Stripe/CheckoutForm";
import { AuthContext } from "@/pages/_app";

export interface PurchaseButtonProps {
  className: string;
  onClick: () => void;
  packageType?: "BBL" | "NRL" | "FULL";
  packageId?: string;
  price?: string;
  description?: string;
  priceId?: string;
  purchaseType?: string;
}

const PurchaseButton = ({
  className,
  onClick,
  packageType,
  packageId = "",
  price,
  description,
  priceId,
  purchaseType,
}: PurchaseButtonProps) => {
  const context = useContext(AuthContext);
  return (
    <CheckoutForm
      userId={context.authContext?.userId ?? ""}
      packageType={packageType}
      packageId={packageId}
      price={price}
      description={description}
      priceId={priceId}
      purchaseType={purchaseType}
    />
  );
};

export default PurchaseButton;
